import { render, staticRenderFns } from "./InqueryM.vue?vue&type=template&id=1dfc70fe&scoped=true&"
import script from "./InqueryM.vue?vue&type=script&lang=js&"
export * from "./InqueryM.vue?vue&type=script&lang=js&"
import style0 from "./InqueryM.vue?vue&type=style&index=0&id=1dfc70fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfc70fe",
  null
  
)

component.options.__file = "InqueryM.vue"
export default component.exports